import type { Feature } from '@exodus/dependency-types';

import mpcClientDefinition from '@/background/features/passkey/mpc-client';
import passkeyApiDefinition from './api.js';
import passkeyModuleDefinition from './module/index.js';
import shareActivityPluginDefinition from './plugin.js';

const passkey = () => {
  return {
    id: 'passkey',
    definitions: [
      { definition: passkeyModuleDefinition },
      { definition: mpcClientDefinition },
      { definition: passkeyApiDefinition },
      { definition: shareActivityPluginDefinition },
    ],
  } satisfies Feature;
};

export default passkey;
